import { render, staticRenderFns } from "./choiceVolunteerBtn.vue?vue&type=template&id=4b094318&scoped=true"
import script from "./choiceVolunteerBtn.vue?vue&type=script&lang=js"
export * from "./choiceVolunteerBtn.vue?vue&type=script&lang=js"
import style0 from "./choiceVolunteerBtn.less?vue&type=style&index=0&id=4b094318&lang=less&scoped=true&external"
import style1 from "./choiceVolunteerBtn.vue?vue&type=style&index=1&id=4b094318&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b094318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b094318')) {
      api.createRecord('4b094318', component.options)
    } else {
      api.reload('4b094318', component.options)
    }
    module.hot.accept("./choiceVolunteerBtn.vue?vue&type=template&id=4b094318&scoped=true", function () {
      api.rerender('4b094318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ChoiceVolunteerBtn/choiceVolunteerBtn.vue"
export default component.exports